import { Button } from "antd";
import styled from "styled-components";
import { StyledCheckIcon } from "../Style";
import { useTranslation } from "next-i18next";

const StyledApiPriceCellWrapper = styled.div`
  border: 1px solid rgb(234, 234, 234);
  padding: 24px 15px;
  margin: 10px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;    
  .planName {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
  }
  .desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: rgb(119, 119, 119);
    margin-top: 0;
  }
  .credit-price {
    font-size: 24px;
    font-weight: 500;
    margin: 30px 0;
    .small {
    font-size: 12px;
    line-height: 40px;
    }

    .pricing {
      color: #222;
      font-size: 30px;
      font-style: normal;
      font-weight: 500;
      line-height: 40px; /* 133.333% */
      letter-spacing: -1px;

      .per-month {
        font-size: 16px;
      }
    }

    .credits {
      color: #4B4F58;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }

  .price-button-container {
    text-align: center;
  }

  .btn-dummy {
    width: 226px;
    height: 36px;
  }
  .btn {
    width: 226px;
    height: 36px;
    background-color: rgb(48, 117, 246);
    border: none;
    border-radius: 4px;
    color: rgb(255, 255, 255);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.3s, opacity 0.3s;
  }
  .btn-current {
    cursor: not-allowed;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    background: rgba(0, 0, 0, 0.04);
    box-shadow: none;    
  }
  .btn-contact {
    border-radius: 4px;
    border: 1px solid #3075f6;
    color: black;
    background-color: white;
  }
  .contents {
    color: rgb(0, 0, 0);
    font-size: 13px;
    line-height: 18px;
    letter-spacing: 0px;
    margin-top: 30px;
    .contents-title {
      font-weight: 600;
      text-align: left;
      margin-top: 10px;
      margin-left: 15px;
    }
    .contents-list {
      font-weight: 400;
      text-indent: -18px;
      padding-left: 18px;
      white-space: pre-line;
    }
  }
`;

export interface ApiPriceCellProps {
  planName: string;
  desc: string;
  credit?: number | null;
  price: string | null;
  includeTitle: string;
  includes: string[];
  equalTitle?: string | null;
  equals?: string[] | null;
  currentPlan: string;
  allPlans: Object[];
  t: any;
  startSubscription: (plan: string, period: boolean, seats?: number) => void;
  upgradeSubscription: (plan: string, period: boolean, seats?: number) => void;
  downgradeSubscription: (plan: string, period: boolean, seats?: number) => void;
}

const PriceButton = ({
  planName, 
  currentPlan, 
  // allPlans,
  startSubscription,
  upgradeSubscription,
  // downgradeSubscription
}: {
  planName: string, 
  currentPlan: string, 
  allPlans: Object[],
  startSubscription: (plan: string, period: boolean, seats?: number) => void;
  upgradeSubscription: (plan: string, period: boolean, seats?: number) => void;
  downgradeSubscription: (plan: string, period: boolean, seats?: number) => void;
}) => {
  const { t } = useTranslation('common');
  const pn = planName.toLocaleLowerCase()
  let state = "block";  //block, current, start, upgrade, contact
  if(currentPlan === "free") {
    state = pn.includes("free") ? "current" 
    : pn.includes("standard") ? "start" 
    : pn.includes("premium") ? "start"
    : pn.includes("enterprise") ? "contact" : "block"
  }
  if(currentPlan === "standard") {
    state = pn.includes("standard") ? "current" 
    : pn.includes("premium") ? "upgrade"
    : pn.includes("enterprise") ? "contact" : "block"
  }
  if(currentPlan === "premium") {
    state = pn.includes("premium") ? "current"
    : pn.includes("enterprise") ? "contact" : "block"
  }
  if(currentPlan === "enterprise") {
    state = pn.includes("enterprise") ? "contact" : "block"
  }

  // console.log("!@#!@#!@# state ", state, pn, currentPlan, allPlans);

  const handleContact = (event: React.MouseEvent) => {
    if (window?.dataLayer?.push) {
      window.dataLayer.push({
        event: "generate_leads_enterprise_start",
        product_name: "AI Studios",
        location: "popup",
      });
    }
    event.preventDefault();
    const url = "https://www.aistudios.com/company/contact";
    window.open(url);
  };

  // const startSubscription = useCallback(() => {
  //   const planInfo = allPlans.find((v) => pn.includes(v.mark) )  //db plan.mark === "premium" | "standard"
  //   if(!planInfo) return alert("PlanInfo is not detected.")
  //   const planId = planInfo?.planId?.monthly;
  //   if(!planId) return alert("PlanId is not detected.")
  //   console.log("!@#!@#!@# planId ", planId, planInfo);



  // }, [allPlans, pn])


  return <>
    {state === "block" && <div className="btn-dummy"></div>}
    {state === "current" && <Button className="btn btn-current" disabled>{t("Your current plan")}</Button>}
    {state === "start" && <Button className="btn btn-start" onClick={() => startSubscription(pn, true)}>{t("Get Started")}</Button>}
    {state === "upgrade" && <Button className="btn btn-upgrade" onClick={() => upgradeSubscription(pn, true)}>{t("Upgrade")}</Button>}
    {state === "contact" && <Button className="btn btn-contact" onClick={(e) => handleContact(e)}>{t("Contact Us")}</Button>}
  </>

}

export const ApiPriceCell = (props: ApiPriceCellProps) => {
  // console.log("!@#!@#!@# ", props);
  const {
    planName, 
    desc, 
    credit, 
    price, 
    includeTitle, 
    includes, 
    equalTitle, 
    equals, 
    currentPlan, 
    allPlans, 
    t,
    startSubscription,
    upgradeSubscription,
    downgradeSubscription
  } = props;
    
  return <StyledApiPriceCellWrapper className="wrapper">
    <p className="planName">{planName}</p>
    <p className="desc">{desc}</p>
    <div className="credit-price">
      <div className="pricing">
        {!credit ? (
          t("Let's Talk")
        ) : (
          <>
            {price || 0}
            <span className="per-month">/{t("Mo")}</span>
          </>
        )}
      </div>
      <div className="credits">
        {!credit
          ? t("Custom Credit")
          : t("{{credits}} Credits", { credits: credit })}
      </div>
    </div>
    <div className="price-button-container">
      <PriceButton
        planName={planName} 
        currentPlan={currentPlan}
        allPlans={allPlans}
        startSubscription={startSubscription}
        upgradeSubscription={upgradeSubscription}
        downgradeSubscription={downgradeSubscription}    
      />
    </div>
    <div className="contents">
      <p className="contents-title">{includeTitle}</p>
      {includes.map((str, index) => <p className="contents-list" key={index+"_key1"}><StyledCheckIcon />{str}</p>)}
    </div>
    <div className="contents">
      <p className="contents-title">{equalTitle}</p>
      {equals?.map((str, index) => <p className="contents-list"  key={index+"_key2"}><StyledCheckIcon />{str}</p>)}
    </div>
  </StyledApiPriceCellWrapper>
}